module.exports = __webpack_public_path__ + "3401a72c081130673da9e0d2e1b094bd.jpg";